const cityViewCopy = {
  en: {
    whileTraveling: "While you're studying in",
    the: "the",
    more: "More",
    travelGuidesToExplore: "cities to explore",
    looksLikeYoureIn: "Looks like you're in XX right now",
    wantToSee: "Want to see our Travel Guide for XX?",
    wishYouWereHere: "Wish you were here",
    nextTime:
      "Looks like you're not in XX right now. Next time you're visiting, be sure to check out the Travel Guide and see what's nearby.",
    acceptedPaymentsIn:
      "Use your UnionPay card wherever you see these logos at checkout:",
    nilson: "According to the Feb 2023 issue of the Nilson Report.",
    unionPayCallout: (
      <>
        <b>Looking for ways to save?</b> Don't miss your exclusive UnionPay
        travel offers.
      </>
    ),
    honolulu: {
      shortGreeting: "Aloha!",
      marqueeHeadline: "Aloha! Let's explore Honolulu.",
      mobileHeadline: "Aloha Honolulu!",
      travelGuideHeadline:
        "The top Honolulu hot spots our cardholders visit most",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    losangeles: {
      shortGreeting: "Hey!",
      marqueeHeadline: "Hey! Let's explore Los Angeles.",
      mobileHeadline: "Hey Los Angeles!",
      travelGuideHeadline:
        "The can't-miss L.A. destinations according to cardholders",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    newyork: {
      shortGreeting: "Hi!",
      marqueeHeadline: "Hi! Let's explore New York City.",
      mobileHeadline: "Hi New York City!",
      travelGuideHeadline:
        "The ultimate list of NYC hot spots, according to cardholders",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos:",
    },
    miami: {
      shortGreeting: "Hola!",
      marqueeHeadline: "Hola! Let's explore Miami.",
      mobileHeadline: "Hola Miami!",
      travelGuideHeadline: "Miami's must-see spots, according to cardholders",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    sanjuan: {
      shortGreeting: "Hola!",
      marqueeHeadline: "Hola! Let's explore San Juan.",
      mobileHeadline: "Hola San Juan!",
      travelGuideHeadline:
        "The hottest spots in San Juan, according to cardholders",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    dubai: {
      shortGreeting: "Salam!",
      marqueeHeadline: "Salam! Let's explore Dubai.",
      mobileHeadline: "Salam Dubai!",
      travelGuideHeadline:
        "See the top destinations across Dubai cardholders visit most",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    tokyo: {
      shortGreeting: "こんにちは",
      marqueeHeadline: "Konnichiwa! Let's explore Tokyo.",
      mobileHeadline: "Konnichiwa Tokyo!",
      travelGuideHeadline: "Tokyo's top destinations, according to cardholders",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    seoul: {
      shortGreeting: "여보!",
      marqueeHeadline: "An nyeong ha seyo! Let's explore Seoul.",
      mobileHeadline: "An nyeong ha seyo Seoul!",
      travelGuideHeadline:
        "Cardholders say these are the can't-miss stops in Seoul",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    vancouver: {
      shortGreeting: "Hey there!",
      marqueeHeadline: "Hey there! Let's explore Vancouver.",
      mobileHeadline: "Hey there Vancouver!",
      travelGuideHeadline: "Our cardholder's favorite spots across Vancouver",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    toronto: {
      shortGreeting: "Hey there!",
      marqueeHeadline: "Hey there! Let's explore Toronto.",
      mobileHeadline: "Hey there Toronto!",
      travelGuideHeadline:
        "The top Toronto travel spots our cardholders keep visiting",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    bangkok: {
      shortGreeting: "สวัสดี!",
      marqueeHeadline: "Sawasdee! Let's explore Bangkok.",
      mobileHeadline: "Sawasdee Bangkok!",
      travelGuideHeadline:
        "Bangkok's best destinations according to cardholders",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    london: {
      shortGreeting: "Hello!",
      marqueeHeadline: "Hello! Let's explore London.",
      mobileHeadline: "Hello London!",
      travelGuideHeadline:
        "Our cardholder's ultimate list of London destinations",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    berlin: {
      shortGreeting: "Hallo!",
      marqueeHeadline: "Hallo! Let's explore Berlin.",
      mobileHeadline: "Hallo Berlin!",
      travelGuideHeadline: "The best of Berlin according to cardholders",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    istanbul: {
      shortGreeting: "Merhaba!",
      marqueeHeadline: "Merhaba! Let's explore Istanbul.",
      mobileHeadline: "Merhaba Istanbul!",
      travelGuideHeadline:
        "The top Istanbul destinations our cardholders visit most",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    lisbon: {
      shortGreeting: "Olá!",
      marqueeHeadline: "Olá! Let's explore Lisbon.",
      mobileHeadline: "Olá Lisbon!",
      travelGuideHeadline: "The top travel spots cardholders love in Lisbon",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    cancun: {
      shortGreeting: "Hola",
      marqueeHeadline: "Hola! Let's explore Cancun.",
      mobileHeadline: "Hola Cancun!",
      travelGuideHeadline: "Cancun's can't-miss spots according to cardholders",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    rome: {
      shortGreeting: "Salvē!",
      marqueeHeadline: "Salvē! Let's explore Rome.",
      mobileHeadline: "Salvē Rome!",
      travelGuideHeadline: "Cardholder's top travel spots across Rome",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    barcelona: {
      shortGreeting: "Hola!",
      marqueeHeadline: "Hola! Let's explore Barcelona.",
      mobileHeadline: "Hola Barcelona!",
      travelGuideHeadline: "The best of Barcelona according to cardholders",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    paris: {
      shortGreeting: "Salut!",
      marqueeHeadline: "Salut! Let's explore Paris.",
      mobileHeadline: "Salut Paris!",
      travelGuideHeadline: "Top Parisian hot spots our cardholders love",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    singapore: {
      shortGreeting: "你好",
      marqueeHeadline: "Hello! Let's explore Singapore.",
      mobileHeadline: "Hello Singapore!",
      travelGuideHeadline: "Singapore's best spots our cardholders visit most",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    seville: {
      shortGreeting: "Hola",
      marqueeHeadline: "Hola! Let's explore Seville.",
      mobileHeadline: "Hola Seville!",
      travelGuideHeadline:
        "The Seville destinations our cardholders visit again and again",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    madrid: {
      shortGreeting: "Hola",
      marqueeHeadline: "Hola! Let's explore Madrid.",
      mobileHeadline: "Hola Madrid!",
      travelGuideHeadline: "Our cardholder's most-visited places in Madrid",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
    doha: {
      shortGreeting: "Salam alaykum!",
      marqueeHeadline: "Salam alaykum! Let's explore Doha.",
      mobileHeadline: "Salam alaykum Doha!",
      travelGuideHeadline:
        "The Doha destinations our cardholders keep visiting",
      travelGuideBody:
        "And we think you’ll see why. These are some of the most popular spots to eat, shop, stay and explore—and this is just the start. Your card is accepted at thousands more places all over town, and everywhere you see these logos.",
    },
  },
};

export default cityViewCopy;
